export default __webpack_public_path__ + "static/media/Martingale.384c05b9.png";